/**
 * Retail page shell — Каса (POS) | Залиха (stock) tabs.
 * POS logic lives in KasaTab; stock/low-stock lives in ZalihaTab.
 */
import { type ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeader } from '../../components/ui/Layout.js';
import { Tabs } from '../../components/ui/Tabs.js';

import { KasaTab } from './KasaTab.js';
import { ZalihaTab } from './ZalihaTab.js';

export function RetailPage(): ReactNode {
  const { t } = useTranslation();
  const [tab, setTab] = useState<'kasa' | 'zaliha'>('kasa');

  return (
    <div className="grid gap-5">
      <PageHeader title={t('nav.retail')} subtitle={t('retail.subtitle')} />

      <Tabs
        value={tab}
        onValueChange={(v) => setTab(v as 'kasa' | 'zaliha')}
        items={[
          { value: 'kasa', label: t('retail.tabs.kasa') },
          { value: 'zaliha', label: t('retail.tabs.zaliha') },
        ]}
      />

      {tab === 'kasa' ? <KasaTab /> : <ZalihaTab />}
    </div>
  );
}
